module.exports = __webpack_public_path__ + "img/vip-icon-3.67e92b88.png";